import styled, { css } from 'styled-components';
import { H4, PrimaryButton, Text } from 'styles/Typography.styled';

export const FormWrapper = styled.form`
    align-items: center;
    display: grid;
    grid-gap: 24px;
`;

export const Privacy = styled.div`
    display: grid;
    grid-template-columns: 24px 1fr;
    gap: 16px;
    margin-bottom: 10px;
`;

export const ButtonFormWrapper = styled.div<{ isModal?: boolean }>(
    ({ isModal }) => css`
        display: flex;
        justify-content: ${isModal ? 'center' : 'start'};
        padding: 0 32px;
        width: 100%;
        z-index: 10;
    `,
);

export const ContactTitle = styled(H4)`
    margin-bottom: 8px;
    text-align: center;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin-top: 8px;
    margin-bottom: 6px;
`;

export const PhoneWrapper = styled.div`
    width: 100%;
    position: relative;
`;

export const PrivacyInfo = styled(Text)(
    ({ theme: { fontSizes } }) => css`
        font-size: ${fontSizes.f12}px;
        line-height: 20px;
    `,
);

export const StyledButton = styled(PrimaryButton)`
    margin: 0 auto;
    width: 100%;
`;

export const ErrorMesaggeWrapper = styled.div`
    margin-left: 30px;
`;
